import axios from "axios";

const url = process.env.REACT_APP_API_URL_PBUMKU
const urlUmkuOss = process.env.REACT_APP_API_URL_PBUMKU_OSS
const contentType = 'application/json'

export default class PbUmkuService {

    syncNibFromOss(nib) {
        return axios.get(urlUmkuOss + '/get_data_oss.php?cari=' + nib)
    }

    ambilNomorService(jenisPenomoran, kodePusat, tahunAgenda, username) {
        return axios.get(url + '/ambil-nomor?jenisPenomoran=' + jenisPenomoran + '&kodePusat=' + kodePusat + '&tahunAgenda=' + tahunAgenda + '&username=' + username)
    }

    listPenandatangan(nama, page, size) {
        let param = ''
        if (nama !== null) {
            param += '&nama=' + nama
        }
        return axios.get(url + '/penandatangan?page=' + page + '&size=' + size + param)
    }

    listOssHeader(nib, page, size) {
        let param = '';
        let stsAktif = '1'
        if (nib !== null) {
            param += '&nib=' + nib
        }
        return axios.get(url + '/oss-header?page=' + page + '&size=' + size + '&stsAktif=' + stsAktif + param)
    }

    getDataOssById(id) {
        return axios.get(url + '/oss-data/' + id)
    }

    getOssHeader(id) {
        return axios.get(url + '/oss-header/' + id)
    }

    ossHeaderList(nib, kdUnit, kdProp, page, size) {
        let param = '';
        if (nib !== null) {
            param += '&nib=' + nib
        }
        if (kdUnit !== null) {
            param += '&kdUnit=' + kdUnit
        }
        if (kdProp !== null) {
            param += '&kdProp=' + kdProp
        }
        return axios.get(url + '/oss-header-list?page=' + page + '&size=' + size + param)
    }

    findOssProyekById(id) {
        return axios.get(url + '/oss-proyek/' + id)
    }

    listOssProyekLokasi(idProyek) {
        return axios.get(url + '/oss-proyek-lokasi?idProyek=' + idProyek)
    }

    findOssChecklistById(id) {
        return axios.get(url + '/oss-checklist/' + id)
    }

    findSptByIdossIdprykIdchecklist(idoss, idpryk, idchecklist) {
        return axios.get(url + '/umku-spt?idoss=' + idoss + '&idpryk=' + idpryk + '&idchecklist=' + idchecklist)
    }

    saveSpt(jsondata) {
        return axios.post(url + '/umku-spt', jsondata, {
            headers: {
                'Content-Type': contentType
            }
        })
    }

    listChecklistDokumen(page, size) {
        return axios.get(url + '/checklist-dokumen?page=' + page + '&size=' + size)
    }

    findChecklistDokumenById(id) {
        return axios.get(url + '/checklist-dokumen/' + id)
    }

    saveLaporanHeader(jsondata) {
        return axios.post(url + '/umku-lap-header', jsondata, {
            headers: {
                'Content-Type': contentType
            }
        })
    }

    editLaporanHeader(jsondata) {
        return axios.put(url + '/umku-lap-header', jsondata, {
            headers: {
                'Content-Type': contentType
            }
        })
    }

    findLaporanHeaderById(id) {
        return axios.get(url + '/umku-lap-header/' + id)
    }

    findLaporanHeaderByIdossIdprykIdchecklistIdspt(idoss, idpryk, idchecklist, idspt) {
        return axios.get(url + '/umku-lap-header?idoss=' + idoss + '&idpryk=' + idpryk + '&idchecklist=' + idchecklist + '&idspt=' + idspt)
    }

    saveLaporanFile(jsondata) {
        return axios.post(url + '/umku-laporan-file', jsondata, {
            headers: {
                'Content-Type': contentType
            }
        })
    }

    listLaporanFile(idlaphdr, page, size) {
        let param = '0'
        if (idlaphdr !== 0) {
            param = idlaphdr
        }
        return axios.get(url + '/umku-laporan-file?page=' + page + '&size=' + size + '&idlaphdr=' + param)
    }

    findLaporanFileById(idlapfile) {
        return axios.get(url + '/umku-laporan-file/' + idlapfile)
    }

    listLaporanLampiran(idlaphdr, page, size) {
        let param = '0'
        if (idlaphdr !== 0) {
            param = idlaphdr
        }
        return axios.get(url + '/umku-lap-lampiran?page=' + page + '&size=' + size + '&idlaphdr=' + param)
    }

    findLaporanLampiranById(idlaplamp) {
        return axios.get(url + '/umku-lap-lampiran/' + idlaplamp)
    }

    saveLaporanLampiran(jsondata) {
        return axios.post(url + '/umku-lap-lampiran', jsondata, {
            headers: {
                'Content-Type': contentType
            }
        })
    }

    viewTte(idPermohonan){
        return axios.get(url + '/view-tte/'+idPermohonan)
    }
}